import React from 'react';
import { Form } from 'react-bootstrap';
import type { ChangeDateRevision } from '../../../types/changes';
import { formatDateTimeLabel, formatGovernanceDate } from '../goLiveWindow';

function displayRevisionLabel(label: string): string {
  if (/^\d{4}-\d{2}-\d{2}T/.test(label)) return formatDateTimeLabel(label);
  if (/^\d{4}-\d{2}-\d{2}$/.test(label)) return formatGovernanceDate(label);
  return label;
}

interface Props {
  revision?: ChangeDateRevision | null;
  /** No formulário de edição mostra quantas trocas ainda restam. */
  showRemaining?: boolean;
}

const ChangeDateRevisionHistory: React.FC<Props> = ({ revision, showRemaining = false }) => {
  if (!revision || (!revision.previous_labels.length && !revision.locked && !showRemaining)) {
    return null;
  }
  return (
    <div className="small text-muted mt-1" data-testid="date-revision-history">
      {revision.previous_labels.map((label, index) => (
        <div key={`${label}-${index}`}>{displayRevisionLabel(label)}</div>
      ))}
      {showRemaining && !revision.locked ? (
        <Form.Text className="text-muted d-block">
          Ainda é possível alterar {revision.remaining} de {revision.limit} vez(es).
        </Form.Text>
      ) : null}
      {revision.locked ? (
        <Form.Text className="text-muted d-block">
          Este campo já foi alterado o máximo de {revision.limit} vez(es).
        </Form.Text>
      ) : null}
    </div>
  );
};

export default ChangeDateRevisionHistory;
